module.exports = __webpack_public_path__ + "operace-usnich-boltcu_6_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/operace-usnich-boltcu_6_before.jpg
// module id = 1222
// module chunks = 0